var React = require('react');

function FlagVc (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#ffe15a","d":"M114.76 88.277h282.48v335.45H114.76z","key":0}),React.createElement("path",{"d":"M503.172 423.721h-105.93V88.273h105.931a8.829 8.829 0 018.828 8.828v317.792a8.83 8.83 0 01-8.829 8.828z","fill":"#73af00","key":1}),React.createElement("path",{"d":"M8.828 88.273h105.931v335.448H8.828A8.829 8.829 0 010 414.893V97.101a8.829 8.829 0 018.828-8.828z","fill":"#4173cd","key":2}),React.createElement("g",{"fill":"#73af00","key":3},React.createElement("path",{"d":"M191.886 251.475l28.635 57.271 28.636-57.271-28.636-57.271zM262.843 251.475l28.636 57.271 28.635-57.271-28.635-57.271zM227.364 320.327l28.635 57.27 28.636-57.27-28.636-57.271z"}))]);
}

FlagVc.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagVc;

FlagVc.default = FlagVc;
